import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataMaterialsService } from '@components/materials/data-materials.service';
import { Event, getEvent } from '@custom-types/event';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { ModelsToolsService } from '@providers/models-tools/models-tools.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.less']
})
export class DashboardComponent {
  @ViewChild('root', { static: false }) root;
  project: any;
  notifications: any[];
  events: any[];

  constructor(
    private router: Router,
    private globalDataService: GlobalDataService,
    private requestService: RequestService,
    private requestV2Service: RequestV2Service,
    private modelsToolsService: ModelsToolsService,
    public dataMaterialsService: DataMaterialsService
  ) {
    this.notifications = [];

    this.globalDataService.getCurrentProject().subscribe(async (project) => {
      this.project = project;
      this.notifications = [];

      if (project == null || !this.dataMaterialsService.refreshData) {
        return;
      }

      this.fillEvents();

      const notificationsResults = await this.requestV2Service.getNotifications(project.id);
      if (notificationsResults.items) {
        this.notifications = notificationsResults.items.map((item) => {
          const notification = {
            caption: item.email.subject,
            href: '#'
          };
          if (item.label.includes('file')) {
            notification.href = `/project/${this.project.id}/files`;
          } else if (item.label.includes('quotation')) {
            notification.href = `/project/${this.project.id}/quotations`;
          }
          return notification;
        });
      }

      this.dataMaterialsService.currentProject = project;

      await this.dataMaterialsService.computeProjectMaterialsData();

      this.dataMaterialsService.refreshData = false;
    });
  }

  fillEvents() {
    this.events = [];

    Object.keys(this.project.dates).forEach((key: string) => {
      const event = getEvent(key, this.project.dates[key]);
      if (event === null) {
        return;
      }

      if (!this.eventToAdd(event)) {
        return;
      }
      this.events.push(event);
    });

    // Si date recalée supprimer le reste
    const endWorkIndex = this.events.map(item => item.type).indexOf('finalEndWork');
    if (endWorkIndex !== -1) {
      const expectedIndex = this.events.map(item => item.type).indexOf('endProject');
      const contractIndex = this.events.map(item => item.type).indexOf('endWork');
      if (expectedIndex !== -1) {
        this.events.splice(expectedIndex, 1);
      }
      if (contractIndex !== -1) {
        this.events.splice(contractIndex, 1);
      }
    }

    // Si dates contractuelles supprimer les autres
    const contractIndex = this.events.map(item => item.type).indexOf('endWork');
    if (contractIndex !== -1) {
      const endWorkIndex = this.events.map(item => item.type).indexOf('finalEndWork');
      const expectedIndex = this.events.map(item => item.type).indexOf('endProject');
      if (endWorkIndex !== -1) {
        this.events.splice(endWorkIndex, 1);
      }
      if (expectedIndex !== -1) {
        this.events.splice(expectedIndex, 1);
      }
    }

    const expectedIndex = this.events.map(item => item.type).indexOf('endProject');
    if (expectedIndex !== -1) {
      const endWorkIndex = this.events.map(item => item.type).indexOf('finalEndWork');
      const contractIndex = this.events.map(item => item.type).indexOf('endWork');
      if (endWorkIndex !== -1) {
        this.events.splice(endWorkIndex, 1);
      }
      if (contractIndex !== -1) {
        this.events.splice(contractIndex, 1);
      }
    }

    if (!this.modelsToolsService.isDesignStep(this.project._related.steps[0].id)) {
      const progressEvent: Event = {
        label: `Avancement planning : ${this.getProgress(this.project.progress)}`,
        date: '',
        type: 'progress'
      };

      this.events.push(progressEvent);
    }
  }

  isDesignStep() {
    return this.project.step === 'agreement_signed' || this.project.step === 'contract_sent';
  }

  eventToAdd(event: Event) {
    if (this.isDesignStep()) {
      switch (event.type) {
        case 'materialsCheck':
        case 'contractSign':
        case 'startProject':
        case 'endProject':
          return true;

        default:
          return false;
      }
    }

    switch (event.type) {
      case 'startWork':
      case 'endWork':
      case 'finalEndWork':
        return true;

      default:
        return false;
    }
  }

  getProgress(progress: string) {
    switch (progress) {
      case 'compliant':
        return 'Conforme';
      case 'minor':
        return 'Retard mineur';
      case 'critical':
        return 'Retard critique';
    }
  }

  public onNavigateTo(...target) {
    this.router.navigate(['projects', this.project.id, ...target]);
  }

  public checkStep() {
    if (this.project && this.globalDataService.steps) {
      const currentStep = this.globalDataService.steps
        .find(s => s.id === this.project.id_project_step);

      if (currentStep) {
        return !this.globalDataService.checkStepIsBefore(currentStep.slug, 'handoff_meeting');
      }

      return false;
    }

    return false;
  }
}
